"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pettorazza-grimani": {
    "c10408e2": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "skipSearch": false
    }],
    "giaron": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7146d07": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "skipSearch": false
    }],
    "papafava": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e59b8725": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "skipSearch": false
    }],
    "pilotta": [{
      "hkey": "a59625de",
      "slug": "pettorazza-grimani",
      "name": "Pettorazza Grimani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;